import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { API_URL } from "../../const/api";
import { selectCurrency, selectId, selectUser, selectTipo } from "../../features/user/userSlice";
import { useWrapperWithdraw } from "../../hooks/useWrapper";
import { AsideMenuRetiro, WithdrawCard, ExpandIcon, DepositTerms } from "./DepositElements";

import astropayLogo from '../../assets/images/LOGOASTROPAY.svg';
import retiroLogo from '../../assets/images/logos/RETIRO.svg';
import pay4funLogo from '../../assets/images/logos/PAY4FUN-01.svg';
import payretailerLogo from '../../assets/images/logos/PAY-RETAILERS.svg';
import tupayLogo from '../../assets/images/logos/TUPAY.svg';
import bcp from '../../assets/images/BCP.svg';
import Bbva from '../../assets/images/BBVA-02.svg';
import scotia from '../../assets/images/SCOTIABANK-06.svg';
import interbank from '../../assets/images/INTERBANK-05.svg';
import wester from '../../assets/images/WESTERUNION-07.svg';
import Rtupay from '../../assets/images/RETITUPAY.svg';
import pix from '../../assets/images/PIX-30.svg';
import brasilB from '../../assets/images/BANCODOBRASIL.svg';
import santander from '../../assets/images/SANTANDER-34.svg';
import caixa from '../../assets/images/CAIXA-33.svg';
import bradesco from '../../assets/images/BRADESCO-32.svg';
import boleto from '../../assets/images/BOLETO.svg';
import payfourfun from '../../assets/images/RETIPAY4FUN.svg';
import BEstado from '../../assets/images/BANCOESTADO.svg';
import BFalabella from '../../assets/images/BANCOFALABELLA.svg';
import BChile from '../../assets/images/BANCODECHILE.svg';
import ripley from '../../assets/images/BANCORIPLEY.svg';
import pichincha from '../../assets/images/BANCOPICHINCHA.svg';
import guayaquil from '../../assets/images/BANCOGUAYAQUIL.svg';
import produbanco from '../../assets/images/PRODUBANCO.svg';
import Bpacifico from '../../assets/images/BANCODELPACIFICO.svg';
import redactiva from '../../assets/images/REDACTIVA.svg';
import RetiraMonnet from '../../assets/images/RETIRACONMONET-01.svg';
import RetiraPF from '../../assets/images/RETIRACONPAGOFACIL.svg';
import bisa from '../../assets/images/BANCOBISA.svg';
import tigomoney from '../../assets/images/BILLETERATIGOMONEY.svg';
import soli from '../../assets/images/BILLETERASOLI.svg';
import simple from '../../assets/images/SIMPLEBOLIVIA.svg';
import bnb from '../../assets/images/BNB.svg';
import santacruz from '../../assets/images/BANCOSANTACRUZ.svg';
import coinspaid from '../../assets/images/ALPHAPO.svg';
import Rcoinspaid from '../../assets/images/RETIRA CON ALPHAPO-01.svg';
import usdt from '../../assets/images/BINANCEPAY.svg';
import Rbetterbro from '../../assets/images/RETIRACONBETTERBRO.svg';
import spei from '../../assets/images/SPEI.svg';
import btc from '../../assets/images/BITCOIN-01.svg';
import tether from '../../assets/images/TETHER-01.svg';
import Realps from '../../assets/images/RETIRACONVALPS.svg';
import Rkushki from '../../assets/images/RETIRACONKUSHKI.svg';
import Mbank from '../../assets/images/MIBANCO.svg';
import Rmibanco from '../../assets/images/RETIRACONMIBANCO.svg';
import star from '../../assets/icons/star.svg';
import pagomovil from '../../assets/images/pagomovil.svg';
import Rpagomovil from '../../assets/images/RETIRACONPAGOMOVIL.svg';
import Rastropay from '../../assets/images/RETIRACONASTROPAY.svg';
import continental from '../../assets/images/G&TContinental.svg';
import banrural from '../../assets/images/BanRural.svg';
import industrial from '../../assets/images/BancoIndustrial.svg';
import promerica from '../../assets/images/BANCOPROMERICA.svg';
import familiarPYG from '../../assets/images/BANCOFAMILIARPARAGUAY.svg';
import atlasPYG from '../../assets/images/BANCOATLASPARAGUAY.svg';
import continentalPYG from '../../assets/images/BANCOCONTINENTALPARAGUAY.svg';
import visionPYG from '../../assets/images/VISIONPARAGUAY.svg';

const PaymentMethodWithdraw = ({ handleActiveWithdrawMethod, selected, actPayRetailer }) => {
  const [t] = useTranslation("global");
  const id_uo = useSelector(selectId);
  const user = useSelector(selectUser);
  const moneda = useSelector(selectCurrency);
  const tipo = useSelector(selectTipo);
  const [actRetail, setActRetail] = useState(false);
  const [actAstro, setActAstro] = useState(false);
  const [actDeposit, setActDeposit] = useState(false);
  const [actTuPay, setActTuPay] = useState(false);
  const [actMonnetChile, setActMonnetChile,] = useState(false); //Monnetchile
  const [actMonnetEcuador, setActMonnetEcuador] = useState(false); //Monnetecuador
  const [actMonnetPeru, setActMonnetPeru] = useState(false); //Monnetperu 
  const [actPagoFacil, setActPagoFacil] = useState(false); //pago 
  const [actCoinspaidRetiroBRL, setActCoinspaidRetiroBRL] = useState(false); //Coinspaid
  const [actBinanceUSD, setActBinanceUSD] = useState(false); //binancepay betterbro
  const [actPix, setActPix] = useState(false); //pix betterbro
  const [actSpei, setActSpei] = useState(false); //Spei betterbro
  const [actBinanceBRL, setActBinanceBRL] = useState(false); //binance otros
  const [actBinanceOtroMXN, setActBinanceOtroMXN] = useState(false); //binance otros
  const [actBinanceOtroARG, setActBinanceOtroARG] = useState(false); //binance otros
  const [actBinanceOtroCOP, setActBinanceOtroCOP] = useState(false); //binance otros
  const [actBinanceOtroCLP, setActBinanceOtroCLP] = useState(false); //binance otros
  const [actBinanceOtroDOP, setActBinanceOtroDOP] = useState(false); //binance otros
  const [actBinanceOtroVES, setActBinanceOtroVES] = useState(false); //binance otros
  const [actBinanceOtroBOB, setActBinanceOtroBOB] = useState(false); //binance otros
  const [actBinanceOtroEUR, setActBinanceOtroEUR] = useState(false); //binance otros
  const [actCoinspaidRetiroMXN, setActCoinspaidRetiroMXN] = useState(false); //Coinspaid
  const [actCoinspaidRetiroARS, setActCoinspaidRetiroARS] = useState(false); //Coinspaid
  const [actCoinspaidRetiroCOP, setActCoinspaidRetiroCOP] = useState(false); //Coinspaid
  const [actCoinspaidRetiroCLP, setActCoinspaidRetiroCLP] = useState(false); //Coinspaid
  const [actCoinspaidRetiroDOP, setActCoinspaidRetiroDOP] = useState(false); //Coinspaid
  const [actCoinspaidRetiroVES, setActCoinspaidRetiroVES] = useState(false); //Coinspaid
  const [actCoinspaidRetiroBOB, setActCoinspaidRetiroBOB] = useState(false); //Coinspaid
  const [actCoinspaidRetiroEUR, setActCoinspaidRetiroEUR] = useState(false); //Coinspaid
  const [actCoinspaidRetiroUSD, setActCoinspaidRetiroUSD] = useState(false); //Coinspaid
  const [actAlpsCH, setActALpsCH] = useState(false); //ALPS chile
  const [actAlpsEC, setActALpsEC] = useState(false); //ALPS ecuador
  const [actAlpsPE, setActALpsPE] = useState(false); //ALPS peru
  const [actKushki, setActKushki] = useState(false); //Kushki peru
  const [actMibancoRetiro, setActMibancoRetiro] = useState(false); //MIBANCO
  const restrictedCurrencies = ['ARS', 'DOP', 'MXN', 'BRL', 'CLP', 'EUR', 'BOB'];
  const [actAstroCH, setActAstroCH] = useState(false); //astropay chile
  const [actAstroARG, setActAstroARG] = useState(false); //astropay argentina
  const [actAstroCO, setActAstroCO] = useState(false); //astropay colombia
  const [actMonnetGuatemala, setActMonnetGuatemala] = useState(false); //Monnet guatemala
  const [actBetterbroPYG, setActBetterbroPYG] = useState(false); //Monnet guatemala
  const [actBDVRetiro, setActBDVRetiro] = useState(false); //bdv venezuela

  useWrapperWithdraw(
    setActRetail,
    //setActAstro,
    setActDeposit,
    setActMonnetPeru,
    setActMonnetChile,
    setActPagoFacil,
    setActBinanceUSD,
    setActPix,
    setActSpei,
    setActBinanceBRL,
    setActBinanceOtroMXN,
    setActBinanceOtroARG,
    setActBinanceOtroCOP,
    setActBinanceOtroCLP,
    setActBinanceOtroDOP,
    setActBinanceOtroVES,
    setActBinanceOtroBOB,
    setActBinanceOtroEUR,
    setActCoinspaidRetiroBRL,
    setActCoinspaidRetiroMXN,
    setActCoinspaidRetiroARS,
    setActCoinspaidRetiroCOP,
    setActCoinspaidRetiroCLP,
    setActCoinspaidRetiroDOP,
    setActCoinspaidRetiroVES,
    setActCoinspaidRetiroBOB,
    setActCoinspaidRetiroEUR,
    setActCoinspaidRetiroUSD,
    setActALpsPE,
    setActALpsCH,
    setActKushki,
    setActMibancoRetiro,
    setActMonnetGuatemala,
    setActAstroCH,
    setActAstroCO,
    setActAstroARG,
    setActBetterbroPYG,
  );

  useEffect(() => {
    const checkCountry = async () => {
      const { data } = await axios.post(API_URL + "getCountryByPhoneNumber", {
        id_uo,
      });
      if (data.status === 1) {
        if (data.response === "EC") {
          setActBinanceUSD(true);
          setActMonnetEcuador(true);
          setActCoinspaidRetiroUSD(true);
          setActALpsEC(true);
        }
      }
    };
    if(moneda==='$') checkCountry();
    if(moneda==='Sol'){
      setActTuPay(true);
    } 

    //if(false) checkCountry();
    if(moneda === 'BOB') {
      setActDeposit(false);
    }

    if (user === "test5") {
      setActBDVRetiro(true);
    }

    if (user === "r0mul0") {
      setActBDVRetiro(true);
    }


  }, []);
  return (<div style={{display: 'flex', flexDirection: 'column'}}>

    <AsideMenuRetiro className={selected?'hideView':null}>

      {actTuPay && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("tupay");
          }}
          className={selected === "tupay" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={wester} alt='wester' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rtupay} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 20,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actMonnetChile && (
          <WithdrawCard
            onClick={() => {
              handleActiveWithdrawMethod("monnet");
            }}
            className={selected === "monnet" ? "active" : null}
          >
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
              <div style={{display: 'flex', justifyContent: 'space-around'}}>
                <img src={BEstado} alt='BEstado' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={BFalabella} alt='BFalabella' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={BChile} alt='BChile' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
                <img src={RetiraMonnet} alt='RetiraMonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              </div>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 20,000 CLP</p>
              </div>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
              </div>
            </div> 
            
          </WithdrawCard>
      )}

      {actAlpsCH && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("Alps");
          }}
          className={selected === "Alps" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
             <img src={BEstado} alt='BEstado' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={BFalabella} alt='BFalabella' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={BChile} alt='BChile' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Realps} alt='Realps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 20,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actAstroCH && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("astropayCH");
          }}
          className={selected === "astropayCH" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px', marginTop:'0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={astropayLogo} alt='astropayLogo' width='120px' height='45px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastropay} alt='Rastropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 20,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000,000 CLP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actMonnetPeru && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("monnetperu");
          }}
          className={selected === "monnetperu" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={ripley} alt='ripley' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={RetiraMonnet} alt='RetiraMonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 100.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actAstro && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("astropay");
          }}
          className={selected === "astropay" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px', marginTop:'0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={astropayLogo} alt='astropayLogo' width='120px' height='45px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastropay} alt='Rastropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $30.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $3,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actMonnetEcuador && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("monnet");
          }}
          className={selected === "monnet" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pichincha} alt='pichincha' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={produbanco} alt='produbanco' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bpacifico} alt='Bpacifico' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={redactiva} alt='redactiva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={RetiraMonnet} alt='RetiraMonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actAlpsEC && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("Alps");
          }}
          className={selected === "Alps" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pichincha} alt='pichincha' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={produbanco} alt='produbanco' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bpacifico} alt='Bpacifico' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={redactiva} alt='redactiva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Realps} alt='Realps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
             <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      
      {actPagoFacil && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("pagofacil");
          }}
          className={selected === "pagofacil" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '20px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bisa} alt='bisa' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={santacruz} alt='santacruz' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={bnb} alt='bnb' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={tigomoney} alt='tigomoney' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={soli} alt='soli' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={RetiraPF} alt='RetiraPF' width='170px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 50.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000 BOB</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actPix && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("Pix");
          }}
          className={selected === "Pix" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px', marginTop:'0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pix} alt='pix' width='120px' height='45px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min BRL 50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actRetail && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("pay4fun");
          }}
          className={selected === "pay4fun" ? "active" : null}
        >
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-46.5px'}}>
          <div style={{display: 'flex', justifyContent: 'space-around'}}>
            <img src={pix} alt='pix' width='120px' height='37px' style={{marginRight: '-79px'}}/>
            <img src={brasilB} alt='brasilB' width='120px' height='37px' style={{marginRight: '-79px'}}/>
            <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-79px'}}/>
            <img src={caixa} alt='caixa' width='120px' height='37px' style={{marginRight: '-79px'}}/>
            <img src={bradesco} alt='bradesco' width='120px' height='37px' style={{marginRight: '-79px'}}/>
            <img src={boleto} alt='boleto' width='120px' height='37px' style={{marginRight: '-79px'}}/>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
            <img src={payfourfun} alt='payfourfun' width='170px' height='40px' style={{marginLeft: '75px'}}/>
          </div>
          <div>
            <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min BRL 50.00</p>
          </div>
          <div>
            <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 5,000.00</p>
          </div>
        </div>
        </WithdrawCard>
      )}

      {actAstroCO && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("astropayCO");
          }}
          className={selected === "astropayCO" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px', marginTop:'0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={astropayLogo} alt='astropayLogo' width='120px' height='45px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastropay} alt='Rastropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 30,000 COP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000,000 COP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}


      {actPayRetailer && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("payretailer");
          }}
          className={selected === "payretailer" ? "active" : null}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "0.35rem",
            }}
          >
            <img
              src={payretailerLogo}
              alt="logo payretailer"
              width="120px"
              height="40px"
            />
            <div style={{ marginLeft: "0.55rem" }}>
              <span style={{ fontWeight: "bold", color: "#000" }}>
              PayRetailers
              </span>
            </div>
          </div>
          
        </WithdrawCard>
      )}

      {actSpei && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("Spei");
          }}
          className={selected === "Spei" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px', marginTop:'0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={spei} alt='Spei' width='120px' height='45px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 50.00 MXN</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 50,000 MXN</p>
            </div>
          </div> 
        </WithdrawCard>
      )}
      
      {actBinanceUSD && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $30.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $3,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actBinanceBRL && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min BRL 30.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroMXN && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100.00 MXN</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000 MXN</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actAstroARG && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("astropayARG");
          }}
          className={selected === "astropayARG" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px', marginTop:'0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={astropayLogo} alt='astropayLogo' width='120px' height='45px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastropay} alt='Rastropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 2,000 ARS</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 900,000 ARS</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroARG && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 5,000 ARS</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 1,500,000 ARS</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroCOP && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 20,000 COP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 4,000,000 COP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroCLP && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 10,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 1,000,000 CLP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroDOP && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 1,000 DOP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 50,000 DOP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {
        (actMibancoRetiro) &&
        <WithdrawCard onClick={()=>{handleActiveWithdrawMethod('mibanco')}} className={selected==='mibanco'?'active':null}>
        {/* Estrella y texto en la esquina superior derecha */}
          <div style={{ 
            position: 'absolute', 
            marginLeft: '165px', 
            marginTop: '-100px', 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: '#30AD19', 
            padding: '2.5px', 
            borderRadius: '9px', 
            border: '1px solid gold', 
            fontSize: '9px', 
            color: 'white', 
            fontWeight: 'bold',
            fontFamily: 'sans-serif'
          }}>
            <img src={star} alt="star" width="12px" height="12px" style={{ marginRight: '2px', marginTop: '-2.5px' }} />
            
            {/* Contenedor para los textos "Nuevo" y "Automático" */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p style={{ margin: 0 }}>Nuevo</p>
              <p style={{ margin: 0 }}>Automático</p>
            </div>
          </div>

          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.5rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pagomovil} alt='pagomovil' width='130px' height='43px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0px', alignItems: 'center'}}>
              <img src={Rpagomovil} alt='Rpagomovil' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 40.000 VES</p>
            </div>
          </div>
        </WithdrawCard>
      }

      {
        (actBDVRetiro) &&
        <WithdrawCard onClick={()=>{handleActiveWithdrawMethod('BDVretiro')}} className={selected==='BDVretiro'?'active':null}>
        {/* Estrella y texto en la esquina superior derecha */}
          <div style={{ 
            position: 'absolute', 
            marginLeft: '165px', 
            marginTop: '-100px', 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: '#30AD19', 
            padding: '2.5px', 
            borderRadius: '9px', 
            border: '1px solid gold', 
            fontSize: '9px', 
            color: 'white', 
            fontWeight: 'bold',
            fontFamily: 'sans-serif'
          }}>
            <img src={star} alt="star" width="12px" height="12px" style={{ marginRight: '2px', marginTop: '-2.5px' }} />
            
            {/* Contenedor para los textos "Nuevo" y "Automático" */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p style={{ margin: 0 }}>Nuevo</p>
              <p style={{ margin: 0 }}>Automático</p>
            </div>
          </div>

          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.5rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pagomovil} alt='pagomovil' width='130px' height='43px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0px', alignItems: 'center'}}>
              <img src={Rpagomovil} alt='Rpagomovil' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 40.000 VES</p>
            </div>
          </div>
        </WithdrawCard>
      }

      {actBinanceOtroVES && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}></p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroBOB && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 30.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000 BOB</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBinanceOtroEUR && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("binanceUSD");
          }}
          className={selected === "binanceUSD" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 30.00 EUR</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 3,000 EUR</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actCoinspaidRetiroBRL && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min BRL 50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroMXN && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 150.00 MXN</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000 MXN</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroARS && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 8,000 ARS</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 1,500,000 ARS</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroCOP && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 30,000 COP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 4,000,000 COP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroCLP && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 20,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 1,000,000 CLP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroDOP && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 2,000 DOP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 50,000 DOP</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroVES && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}></p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroBOB && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 40.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000 BOB</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroEUR && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 30.00 EUR</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 3,000 EUR</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}
      {actCoinspaidRetiroUSD && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("CoinspaidRetiro");
          }}
          className={selected === "CoinspaidRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='38px' style={{marginRight: '-62px'}}/>
              <img src={btc} alt='btc' width='120px' height='38px' style={{marginRight: '-78px'}}/>
              <img src={tether} alt='tether' width='120px' height='38px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rcoinspaid' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $30.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $3,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actAlpsPE && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("Alps");
          }}
          className={selected === "Alps" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
             <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={ripley} alt='ripley' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Realps} alt='Realps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 100.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actKushki && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("Kushki");
          }}
          className={selected === "Kushki" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={wester} alt='wester' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rkushki} alt='Rkushki' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min S/ 50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 5,000.00</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actMonnetGuatemala && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("monnet");
          }}
          className={selected === "monnet" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={industrial} alt='industrial' width='55px' height='37px' style={{marginRight: '-25px' ,  marginLeft: '40px'}}/>
              <img src={banrural} alt='banrural' width='55px' height='37px' style={{marginRight: '-10px' , marginLeft: '32px'}}/>
              <img src={continental} alt='continental' width='55px' height='37px' style={{marginRight: '-40px', marginLeft: '17px'}}/>
              <img src={promerica} alt='promerica' width='55px' height='37px' style={{marginRight: '-40px',  marginLeft: '45px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={RetiraMonnet} alt='RetiraMonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 400.00 GTQ</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000.00 GTQ</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actBetterbroPYG && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("PYGRetiro");
          }}
          className={selected === "PYGRetiro" ? "active" : null}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={familiarPYG} alt='familiarPYG' width='55px' height='37px' style={{marginRight: '-25px' ,  marginLeft: '36px'}}/>
              <img src={atlasPYG} alt='atlasPYG' width='55px' height='37px' style={{marginRight: '-10px' , marginLeft: '30px'}}/>
              <img src={continentalPYG} alt='continentalPYG' width='55px' height='37px' style={{marginRight: '-40px', marginLeft: '15px'}}/>
              <img src={visionPYG} alt='visionPYG' width='55px' height='37px' style={{marginRight: '-40px',  marginLeft: '45px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rbetterbro' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 10,000.00 PYG</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 PYG</p>
            </div>
          </div> 
          
        </WithdrawCard>
      )}

      {actDeposit && (
        <WithdrawCard
          onClick={() => {
            handleActiveWithdrawMethod("retiro");
          }}
          className={selected === "retiro" ? "active" : null}
        >
          {/* Contenedor en columna */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={retiroLogo}
                alt="log"
                width="120px"
                height="37px"
              />
              <div style={{ marginLeft: '0.55rem' }}>
                <span style={{ fontWeight: 'bold', color: '#000000' }}>
                  {t("deposit.direct-transfer")}
                </span>
              </div>
            </div>

            {/* Mostrar solo si la moneda es "Bs.S" */}
            {moneda === "Bs.S" && (
              <div style={{marginTop: '30px', marginBottom: '-10px'}}>
                <p style={{ fontSize: '12px', textAlign: 'center', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold'}}>
                  Min 40.000 VES
                </p>
              </div>
            )}
          </div>
        </WithdrawCard>
      )}
    </AsideMenuRetiro>

    <DepositTerms 
      className={selected ? 'hideView retiro' : "retiro"} 
      style={restrictedCurrencies.includes(moneda) ? { marginTop: '30px', marginBottom: '15px' } : {}}
    >
    <span style={{ textAlign: "justify", display: "block", margin: "0 auto" }}>
        Una vez validada su cuenta de usuario e identidad, el jugador podrá solicitar el retiro de sus ganancias en cualquier momento. Estos procesos <strong>no generan ningún costo</strong>. Le recomendamos <strong> consultar los límites establecidos</strong>. Si tiene alguna consulta o si su solicitud de retiro <strong>no se ha completado satisfactoriamente</strong>, le invitamos a utilizar nuestro chat en vivo para ser asistido por uno de nuestros asesores.
    </span>
    </DepositTerms>

</div>
  );
};

export default PaymentMethodWithdraw;
